import {
    Typography,
    Box,
    Link,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import TickRoundIcon from "../../../icons/TickRoundIcon";
import HourglassIcon from "../../../icons/HourglassIcon";
import TriangleExclamationIcon from "../../../icons/TriangleExclamationIcon";

import baseTheme from "../../../themes/baseTheme";
import React, { useState, useEffect } from "react";
import apiinfo from "../../../utils/base-uri.json";
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";
import EmptyComponent from "../../../utils/EmptyComponent";
import RecentDocumentsListitem from "../DashboardRecentDocument/RecentDocumentsListitem";
import RecentDocumentsGriditem from "../DashboardRecentDocument/RecentDocumentsGriditem";
import { useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import VendorFilters from "../../../pages/VendorSearch/VendorFilters";
import RecentDocumentsCollectionControls from "../DashboardRecentDocument/RecentDocumentCollectionControl";
import CollectionsTemplate from "../../../components/CollectionsTemplate/index";



const pageSize = 12;
const queryUrl = "Documents/GetRecentDocuments";

function vendorDataAdaptor(data,t) {
    return {
        headers: [
            { id: "VendorName", text: t("DashboardRecentDocument.vendorName"), width: "70%" },
            { id: "documentTypeName", text: t("DashboardRecentDocument.documentTypeName"), width: "80%" },
            { id: "vendorStatus", text: "Status", width: "50%" },
            { id: "expirationDate", text: t("DashboardRecentDocument.expirationDate"), width: "50%" },
            { id: "clientName", text: t("DashboardRecentDocument.clientName"), width: "100%" },
            { id: "dateUploaded", text: t("DashboardRecentDocument.dateUploaded"), width: "45%" },

        ],
        rows: data?.data?.map((d) =>
            Object.assign({}, d, {
                key: d.VendorName,
            })
        )
        .sort((a, b) => new Date(b.dateUploaded) - new Date(a.dateUploaded)),
        statusRoleMap: {
            prequalified: {
                text: "Prequalified",
                role: "success",
                icon: TickRoundIcon,
            },
            pending: { text: "Pending", role: "warning", icon: HourglassIcon },
            Processing: { text: "Processing", role: "error", icon: HourglassIcon },
            clientReview: {
                text: "Client Review",
                role: "warningLight",
                icon: HourglassIcon,
            },
            probation: {
                text: "Probation",
                role: "error",
                icon: TriangleExclamationIcon,
            },
        },
    };
}

export default function () {
    const { t } = useTranslation();
    function toQueryString(obj) {
        return "?".concat(
            Object.keys(obj)
                .map((e) =>
                    obj[e] ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}` : null
                )
                .filter((e) => !!e)
                .join("&")
        );
    }

    function getUrl(url, data) {
        return `${url}${toQueryString(data)}`;
    }

    const [allClients, setAllClients] = useState([]);
    const [urlParams, setUrlParams] = useSearchParams();
    const [clientId, setClientId] = useState(
        urlParams.get("clientId") || allClients?.[0]?.id
    );
    const [filterObj, setFilterObj] = useState({});
    const [pageCount, setPageCount] = useState(1);
    const [collection, setCollection] = useState({});
    const [paramsState, setParamsState] = useState({
        pageNumber:1,
        pageSize:12,
        clientId,
        freeText: "",
    });
    const [url, setUrl] = useState(
        getUrl(queryUrl, { ...paramsState, pageSize })
    );
    const { data: collectionData, loading, error } = useFetch(url);

    useLayoutEffect(() => {
        setUrl(getUrl(queryUrl, { ...paramsState, pageSize }));
    }, [paramsState]);

    useLayoutEffect(() => {
        if (collectionData) {
            setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
            setCollection(
                vendorDataAdaptor ? vendorDataAdaptor(collectionData,t) : collectionData
            );
        }
    }, [collectionData]);

    function setSearchStr(str) {
        setParamsState({ ...paramsState, freeText: str, pageNumber: "1" });
    }

    function setPage(pageNumber) {
        setParamsState((prev) => ({ ...prev, pageNumber }));
    }
  
    return (
        <>
            <CollectionsTemplate
                title="Recent Documents"
                TitlebarChildren={EmptyComponent}
                page={paramsState.pageNumber}
                setPage={setPage}
                pageCount={pageCount}
                fetchState={{ loading, error }}
                collection={collection}
                viewType="list"
                responseDataAdaptor={vendorDataAdaptor}
                ListItemComponent={RecentDocumentsListitem}
                GridItemComponent={RecentDocumentsGriditem}
                CollectionControls={(props) => (
                    <RecentDocumentsCollectionControls
                        allClients={allClients}
                        IsDownload={url}
                        setClientId={setClientId}
                        clientId={paramsState.clientId}
                        setSearchStr={setSearchStr}
                        searchStr={paramsState.freeText}
                        searchPlaceholder="Search vendors"
                        {...props}
                    />
                )}
                filterObj={filterObj}
            />
        </>
    );
}